<template>
  <v-container
    :style="{
      height: `${paperHeight}mm`,
      width: `${paperWidth}mm`,
      padding: 0
    }"
    fluid>
    <template v-for="(page, i) in pages">
      <div
        v-if="i"
        :key="'break-before-'+i"
        :style="{
          pageBreakBefore: `always`
        }">
      </div>
      <div
        :key="`page-${i}`"
        :style="{
          height: '100%',
          padding: `${paperPaddingY}mm ${paperPaddingX}mm`,
        }">
        <v-row
          no-gutters>
          <v-col
            v-for="(item, j) in page"
            :key="`barcode-${i}-${j}`"
            :cols="item.colSize">
            <div
              :style="{
                display: 'flex',
                flexDirection: 'column',
                margin: `${itemMarginY / 2}mm ${itemMarginX / 2}mm`,
                padding: `${elementMarginY / 2}mm ${elementMarginX / 2}mm`,
                border: '0.27607px solid #6C6C6C',
                width: `${itemWidth}mm`,
                height: `${itemHeight}mm`,
                overflow: 'hidden',
              }">
              <div
                v-for="(el, k) in elements"
                :key="`barcode-${i}-${j}-${k}-${el}`"
                :style="{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                  flexGrow: el === 'barcode' ? 1 : 0,
                  lineHeight: el === 'barcode' ? 0 : `${itemLineHeight}px`,
                  fontSize: el === 'barcode' ? 0 : `${itemFontSize}px`
                }">
                <template v-if="el === 'name'">
                  <div
                    :style="{
                      margin: `${elementMarginY / 2}mm ${elementMarginX / 2}mm`
                    }">
                    {{ item.name }}
                  </div>
                </template>
                <template v-else-if="el === 'barcode'">
                  <div v-html="item.canvas"></div>
                  <!-- <img :src="item.barcode" /> -->
                  <!-- <img
                    :src="item.barcode"
                    :height="barcodeHeight"
                    width="100%" /> -->
                </template>
                <template v-else-if="el === 'price'">
                  <div
                    :style="{
                      margin: `${elementMarginY / 2}mm ${elementMarginX / 2}mm`
                    }">
                    {{ toLocaleString(item.price) }} บาท
                  </div>
                </template>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </template>
  </v-container>
</template>

<script>
import JsBarcode from 'jsbarcode'
import { VContainer, VRow, VCol } from 'vuetify/lib'
import _ from 'lodash'
import {
  toLocaleString
} from '@shipnity/components/src/filters'

const pxToInt = (px) => {
  if (_.last(px) === '%') return 0
  return parseInt(px, 10)
}
export default {
  components: {
    VContainer,
    VRow,
    VCol

  },
  props: {
    col: {
      type: [Number],
      default: 0
    },
    row: {
      type: [Number],
      default: 0
    },
    my: {
      type: [Number],
      default: 0
    },
    mx: {
      type: [Number],
      default: 0
    },
    omy: {
      type: [Number],
      default: 0
    },
    omx: {
      type: [Number],
      default: 0
    },
    imy: {
      type: [Number],
      default: 0
    },
    width: {
      type: [Number],
      default: 296
    },
    height: {
      type: [Number],
      default: 209
    },
    aspectRatio: {
      type: [Number],
      default: 1
    },
    fontSize: {
      type: [Number],
      default: 7
    },
    lineHeight: {
      type: [Number],
      default: 11
    },
    showBarcodeNumber: Boolean,
    elements: {
      type: [Array],
      default: () => (['name', 'barcode', 'price'])
    },
    items: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      pxRatio: 3.7795275591, // 3.779528
      toLocaleString
    }
  },
  computed: {
    paperWidth () {
      const widthRatio = this.width * this.aspectRatio
      return widthRatio
    },
    paperHeight () {
      const heightRatio = this.height * this.aspectRatio
      return heightRatio
    },
    paperPaddingY () {
      const myRatio = this.my * this.aspectRatio
      return myRatio
    },
    paperPaddingX () {
      const mxRatio = this.mx * this.aspectRatio
      return mxRatio
    },
    itemMarginY () {
      const mxRatio = this.omy * this.aspectRatio
      return mxRatio
    },
    itemMarginX () {
      const myRatio = this.omx * this.aspectRatio
      return myRatio
    },
    elementMarginY () {
      const myRatio = this.imy * this.aspectRatio
      return myRatio
    },
    elementMarginX () {
      const myRatio = this.imy * this.aspectRatio
      return myRatio
    },
    itemWidth () {
      const paperBorderX = this.paperPaddingX * 2
      const colWidth = (this.paperWidth - paperBorderX) / this.col
      const itemBorderX = this.itemMarginX
      return Math.floor(colWidth - itemBorderX)
    },
    itemHeight () {
      const paperBorderY = this.paperPaddingY * 2
      const colWidth = (this.paperHeight - paperBorderY) / this.row
      const itemBorderY = this.itemMarginY
      return Math.floor(colWidth - itemBorderY)
    },
    itemFontSize () {
      const fontSizeRatio = this.fontSize * this.aspectRatio
      return fontSizeRatio
    },
    itemLineHeight () {
      const lineHeightRatio = this.lineHeight * this.aspectRatio
      return lineHeightRatio
    },
    barcodeWidth () {
      const width = Math.floor(this.itemWidth * this.pxRatio)
      const border = 2
      return width - border
    },
    barcodeHeight () {
      const height = Math.floor(this.itemHeight * this.pxRatio)
      const border = 2
      const lineHeight = Math.floor(this.itemLineHeight * this.pxRatio * 2)
      const padding = Math.floor((this.elementMarginY * this.pxRatio))
      const excess = padding + lineHeight + border
      return height - excess
    },
    pages () {
      return this.items.map((page) => page.map((cols) => {
        const colSize = 12 / this.col
        return cols.map((item) => {
          const canvas = document.createElement('svg')
          let format = 'CODE128'
          if (this.$_.isArabic(item.barcode)) {
            if (item.barcode.length === 8) {
              format = 'EAN8'
            } else if (item.barcode.length === 13) {
              format = 'EAN13'
            }
          }
          let validate = false
          let height = this.barcodeHeight
          if (height < 24) {
            height = 24
          }
          const width = this.barcodeWidth ? (pxToInt(this.barcodeWidth) / 1.5) / (35 + item.barcode.length * 6.125) : 1.5
          JsBarcode(canvas, item.barcode, {
            displayValue: this.showBarcodeNumber,
            flat: !this.showBarcodeNumber,
            fontSize: this.itemFontSize,
            margin: 0,
            background: 'transparent',
            width,
            height,
            format,
            valid (valid) {
              validate = valid
              return valid
            }
          })
          if (!validate) {
            JsBarcode(canvas, item.barcode, {
              displayValue: this.showBarcodeNumber,
              flat: !this.showBarcodeNumber,
              fontSize: this.itemFontSize,
              margin: 0,
              background: 'transparent',
              width,
              height,
              format: 'CODE128',
              valid (valid) {
                return valid
              }
            })
          }
          return {
            name: item.name,
            price: item.price,
            canvas: canvas.outerHTML,
            barcode: '', // canvas.toDataURL('image/svg'),
            colSize
          }
        })
      }).flat())
    }
  }
}
</script>
